import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from './containers/App/index.js'
import * as registerServiceWorker from './registerServiceWorker'
import { createBrowserHistory } from 'history'
import { Provider } from 'react-redux'
import { Router, Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import configureStore from './configureStore'
import './assets/css/bootstrap.min.css'
import './assets/css/pages.min.css'
import './assets/css/pages-icons.css'
import './assets/css/app.css'

const store = configureStore()
const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)

const Root = ({ store }) => (
	<Provider store={store}>
		<Router history={createBrowserHistory()}>
			<Route path='/' component={App} />
		</Router>
	</Provider>
)

Root.propTypes = {
	store: PropTypes.object.isRequired
}

//StrictMode are to run in development mode only, they don't
//impact production builds, they are for exposing potential problems in application
root.render(
	// <StrictMode>
		<Root store={store} />
	// </StrictMode>
)
registerServiceWorker.unregister()
